import { LockOutline, MenuOutline, QuestionCircleFill, UserOutline, WarningFill } from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';
// all icons used by the application
export const icons: IconDefinition[] = [
    MenuOutline,
    UserOutline,
    LockOutline,
    QuestionCircleFill,
    WarningFill
];
